import script from "./claim.vue?vue&type=script&setup=true&lang=js"
export * from "./claim.vue?vue&type=script&setup=true&lang=js"

import "./claim.vue?vue&type=style&index=0&id=4bfbd6b0&lang=scss"

const __exports__ = script;

export default __exports__